export enum TransactionDrawerParams {
  EntityId = 'entityId',
  TransactionId = 'transactionId',
}
